module.exports = __webpack_public_path__ + "img/camiseta-preta.d64a8da5.jpg";